module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/group-availability-illustration.svg"